import { MessageDescriptor } from 'react-intl';
import {
  commonErrorMessages,
  communicationsDocumentsMessages,
} from '../../../../messages';
import {
  communicationReportsTypes,
  CommunicationsType,
} from '../../../../model/documents/communications';
import { ErrorMessages } from '../../../../model/error';
import { CommunicationsError } from './communications-types';

export const messagesForCommunicationDocumentsError = (
  error: CommunicationsError
): ErrorMessages => {
  switch (error) {
    case 'GENERIC_ERROR':
    default:
      return {
        title: commonErrorMessages.errorTitleDefault,
        description: commonErrorMessages.errorDescriptionDefault,
      };
  }
};

export const labelForCommunicationsDocumentsType = (
  type?: CommunicationsType
): MessageDescriptor => {
  switch (type) {
    case 'AZFUND_GIORNALIERE':
      return communicationsDocumentsMessages.CommunicationsTypeDailyAzfund;
    case 'PREVIDENZA_GIORNALIERE':
      return communicationsDocumentsMessages.CommunicationsTypeDailyBenefits;
    case 'CONFERMA_OPERAZIONE_AZFUND_SEMESTRALE':
      return communicationsDocumentsMessages.CommunicationsTypeSemiannualAzfundOperationConfirmation;
    case 'CONFERME_GIORNALIERE_FONDI':
      return communicationsDocumentsMessages.CommunicationsTypeDailyFundConfirmations;
    case 'CONFERMA_FONDO_AZSUSTAINABLE_FUTURE':
      return communicationsDocumentsMessages.CommunicationsTypeAzSustainableFutureFundConfirmation;
    case 'CONFERME_NUOVE_GESTIONI_PATRIMONIALI':
      return communicationsDocumentsMessages.CommunicationsTypeNewAssetManagementConfirmations;
    case 'LETTERA_DIVIDENDI':
      return communicationsDocumentsMessages.CommunicationsTypeDividendsLetter;
    case 'CONFERMA_REINVESTIMENTO_DIVIDENDI':
      return communicationsDocumentsMessages.CommunicationsTypeDividendReinvestmentConfirmation;
    case 'LETTERA_BENVENUTO_AFI_ADDENDUM':
      return communicationsDocumentsMessages.CommunicationsTypeAfiServiceWelcomeLetterAddendum;
    case 'LETTERA_BENVENUTO_MAX':
      return communicationsDocumentsMessages.CommunicationsTypeWelcomeLetterMaxService;
    case 'LETTERA_BENVENUTO_PIR':
      return communicationsDocumentsMessages.CommunicationsTypeWelcomeLetterPirService;
    case 'LETTERA_BENVENUTO_AFI':
      return communicationsDocumentsMessages.CommunicationsTypeAfiWelcomeLetter;
    case 'LETTERA_BENVENUTO_SGR':
      return communicationsDocumentsMessages.CommunicationsTypeWelcomeLetterSgr;
    case 'LETTERA_BENVENUTO_GOAL_BASED_PLAN':
      return communicationsDocumentsMessages.CommunicationsTypeWelcomeLetterGoalBasedPlan;
    case 'LETTERA_BENVENUTO_NGA':
      return communicationsDocumentsMessages.CommunicationsTypeWelcomeLetterNga;
    case 'LETTERA_BENVENUTO_NGA_SMART':
      return communicationsDocumentsMessages.CommunicationsTypeWelcomeLetterNgaSmart;
    case 'LETTERA_BENVENUTO_MONO_NGA_SMART':
      return communicationsDocumentsMessages.CommunicationsTypeWelcomeLetterMonoNgaSmart;
    case 'LETTERA_BENVENUTO_MONO_NGA_FULL':
      return communicationsDocumentsMessages.CommunicationsTypeWelcomeLetterMonoNgaFull;
    case 'LETTERA_BENVENUTO_MONO_MAX':
      return communicationsDocumentsMessages.CommunicationsTypeWelcomeLetterMonoMax;
    case 'PERDITE_MIFID_AMMINISTRATO':
      return communicationsDocumentsMessages.CommunicationsTypeMifidRelevantLossesAdministered;
    case 'PERDITE_MIFID_GESTIONI':
      return communicationsDocumentsMessages.CommunicationsTypeMifidRelevantLossesManagement;
    case 'NOTE_INFORMATIVE':
      return communicationsDocumentsMessages.CommunicationsTypeInformationNotes;
    case 'CASE_TERZE_COMUNICAZIONI_AZIONISTI':
      return communicationsDocumentsMessages.CommunicationsTypeThirdPartyShareholders;
    case 'CASE_TERZE_GIORNALIERE':
      return communicationsDocumentsMessages.CommunicationsTypeDailyThirdParty;
    case 'CONFERMA_ORDINE_BOLLO_MONTI':
      return communicationsDocumentsMessages.CommunicationsTypeMontiStampDutyOrderConfirmation;
    case 'CORPORATE_ACTION_RTO':
      return communicationsDocumentsMessages.CommunicationsTypeCorporateActionRto;
    case 'LETTERA_ADV_SCADUTA_CLIENTI_CF_REALI':
      return communicationsDocumentsMessages.CommunicationsTypeLetterAdvExpired;
    case 'LETTERA_ADV_SCADUTA_CLIENTI_CF_TECNICI':
      return communicationsDocumentsMessages.CommunicationsTypeLetterAdvExpired;
    case 'LETTERA_ADV_IN_SCADENZA':
      return communicationsDocumentsMessages.CommunicationsTypeLetterAdvToBeExpired;
    default:
      if (communicationReportsTypes.includes(type as any)) {
        return communicationsDocumentsMessages.CommunicationsTypeReport;
      }

      return {
        id: type || '',
        defaultMessage: (type || '')
          .toLowerCase()
          .replace(/_/g, ' ')
          .replace(/^./, (c) => c.toUpperCase()),
      };
  }
};
